import { z } from 'zod';

import { BookingRoomDescription } from '@/em-api-client-typescript-fetch';

export const BedroomDescription: z.ZodType<BookingRoomDescription> = z.object({
  description: z.string(), // Required
  locale: z.string(), // Required
});
